// https://vuex.vuejs.org/en/state.html

export default {
  horaActual: null,

  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
  drawer: null,
  baseUrlFicheros: 'gs://checkapp-7f8a1.appspot.com/',
  loaded: false,
  langDefecto: 'es',
  langSeleccionado: 'es',
  horaInicio: '06', //la hora dónde se divide el día
  idiomas: [
    {
      value: 'es',
      text: 'Español'
    },
    {
      value: 'en',
      text: 'Inglés'
    },
    {
      value: 'de',
      text: 'Alemán'
    },
    {
      value: 'fr',
      text: 'Francés'
    },
    {
      value: 'it',
      text: 'Italiano'
    },
    {
      value: 'pt',
      text: 'Portugués'
    },
    {
      value: 'ru',
      text: 'Ruso'
    },
    {
      value: 'fi',
      text: 'Finés'
    },
    {
      value: 'sv',
      text: 'Sueco'
    },
  ],
  traduccionesDialog: false,
  traduccionesObj: []
}
